module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <shell></shell>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 844
// module chunks = 0